import { AdvicePriceCalculationResult } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";

export const useAkaAdviceResult = (): CollectiveAdvice | null =>
  useSelector((state: ReduxState) => state.akaAdvice.adviceResult.current);

export const useAdvicePriceCalculationResults = ():
  | AdvicePriceCalculationResult[]
  | null =>
  useSelector(
    (state: ReduxState) =>
      state.akaAdvice.advicePriceCalculationResults.current,
  );

export const useAdviceIsLoading = (): boolean => {
  const adviceIsLoading = useSelector(
    (state: ReduxState) => state.akaAdvice.adviceResult.isLoading,
  );
  const priceIsLoading = useSelector(
    (state: ReduxState) =>
      state.akaAdvice.advicePriceCalculationResults.isLoading,
  );
  return adviceIsLoading || priceIsLoading;
};
